// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterRelationshipCompute } from "hooks/filters/useFilterRelationship";

// #####################################################

const useRelationshipFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { relationship: relationshipUrl } = query || {};

	// ** Filtr - Związki
	const relationshipFilterData = useMemo(() => {
		const relationshipValue =
			filterRelationshipCompute.urlToApiParam(relationshipUrl);
		return relationshipUrl
			? {
					label: t("filtersAndSelectors:relationshipLabel"),
					selected: t(
						`filtersAndSelectors:relationship.${relationshipValue}`
					),
			  }
			: null;
	}, [relationshipUrl, language]);

	// #####################################################

	return relationshipFilterData;
};

// #####################################################

export default useRelationshipFilterData;

// #####################################################
